import { formatDuration, intervalToDuration } from "date-fns";
import { useEffect, useState } from "react";

function formatRemaining(deadline: Date) {
  const now = Date.now();

  if (now >= deadline.getTime()) {
    return null;
  }

  const duration = intervalToDuration({ start: now, end: deadline });
  console.log(duration);

  // If there are no full hours or days left, show a fallback.
  if (!duration.days && !duration.hours) {
    return "less than an hour";
  }

  return formatDuration(duration, { format: ["days", "hours"] });
}

/** Milliseconds from `now` until the start of the next clock hour. */
function msUntilNextHour() {
  const now = new Date();
  const next = new Date(now);
  next.setHours(next.getHours() + 1, 0, 0, 0);
  return next.getTime() - now.getTime();
}

export function Countdown(props: { fromDate: Date }) {
  const { fromDate } = props;
  const [remaining, setRemaining] = useState(() => formatRemaining(fromDate));

  useEffect(() => {
    let cleanupInterval: ReturnType<typeof setInterval> | undefined;

    function tick() {
      setRemaining(formatRemaining(fromDate));
    }

    function initialTick() {
      tick();
      cleanupInterval = setInterval(tick, 60 * 60 * 1000);
    }

    // Schedule the first tick at the next hour boundary, then every hour after.
    const initialTimeout = setTimeout(initialTick, msUntilNextHour());

    return () => {
      clearTimeout(initialTimeout);

      if (cleanupInterval) {
        clearInterval(cleanupInterval);
      }
    };
  }, [fromDate]);

  return remaining;
}
